import { useEffect, useState } from "react";

/**
 * The site knows the day. A live Auckland clock with the practice's
 * phase — for a page whose whole promise is ten minutes in the
 * morning and ten in the evening, the current moment is content.
 */
function aucklandParts() {
  const now = new Date();
  const time = now
    .toLocaleTimeString("en-NZ", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Pacific/Auckland",
    })
    .replace(" ", " ");
  const hour = Number(
    now.toLocaleString("en-NZ", {
      hour: "numeric",
      hour12: false,
      timeZone: "Pacific/Auckland",
    }),
  );
  const phase =
    hour >= 4 && hour < 10
      ? "the morning sit"
      : hour >= 16 && hour < 22
        ? "the evening sit"
        : "between sits";
  return { time, phase };
}

export function AucklandClock({ className = "" }: { className?: string }) {
  const [parts, setParts] = useState(aucklandParts);

  useEffect(() => {
    const id = setInterval(() => setParts(aucklandParts()), 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <span className={`onum whitespace-nowrap ${className}`}>
      Auckland · {parts.time} · {parts.phase}
    </span>
  );
}
